import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../../environments/environment';
import { HttpUtilsService } from '../../../../../../core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from '../../../../../../core/_base/crud';
import { ChiTietPhieuKiemKe, PhieuKiemKe } from '../phieu-kiem-ke-model/phieu-kiem-ke.model';
const API_ROOT_URL = environment.ApiRoot + '/kho';

@Injectable()
export class KhoKiemkekhoService {
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});
	data_import: BehaviorSubject<any[]> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;

	constructor(private http: HttpClient,
		private httpUtils: HttpUtilsService) { }

	getData(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/KhoKiemkekho_List', {
			headers: httpHeaders,
			params: httpParams
		});
	}
	getChiTietKhoKiemkekho(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/KhoKiemkekho_Get_Detail?IdKk=${itemId}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	getSoPhieuTiepTheo(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<PhieuKiemKe>(API_ROOT_URL + '/KhoKiemkekho_Get_NextID', { headers: httpHeaders });
	}
	addDetail(item: ChiTietPhieuKiemKe): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<ChiTietPhieuKiemKe>(API_ROOT_URL + '/KhoKiemkekho_Insert_Detail', item, { headers: httpHeaders });
	}
	addKhoKiemkekho(item: PhieuKiemKe): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<PhieuKiemKe>(API_ROOT_URL + '/KhoKiemkekho_Insert', item, { headers: httpHeaders });
	}
	updateKhoKiemkekhoWithDetail(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<PhieuKiemKe>(API_ROOT_URL + '/KhoKiemkekho_Update_With_Detail', item, { headers: httpHeaders });
	}
	NhapKetQuaKiemKe(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<PhieuKiemKe>(API_ROOT_URL + '/KhoKiemkekho_NhapKiemKe', item, { headers: httpHeaders });
	}
	DuyetKiemKe(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<PhieuKiemKe>(API_ROOT_URL + '/KhoKiemkekho_Duyet', item, { headers: httpHeaders });
	}
	KhongDuyetKiemKe(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<PhieuKiemKe>(API_ROOT_URL + '/KhoKiemkekho_KhongDuyet', item, { headers: httpHeaders });
	}
	KhoKiemkekho_LuuTam(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<PhieuKiemKe>(API_ROOT_URL + '/KhoKiemkekho_LuuTam', item, { headers: httpHeaders });
	}
	deleteKhoKiemkekho(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/KhoKiemkekho_Delete?IdKk=${itemId}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	deleteKhoKiemkekhoItem(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/KhoKiemkekho_DeleteItem?IdCtKk=${itemId}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	cancelKhoKiemkekho(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/KhoKiemkekho_Cancel?IdKk=${itemId}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	updateOnlyKhoKiemkekho(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<PhieuKiemKe>(API_ROOT_URL + '/KhoKiemkekho_Update_Only', item, { headers: httpHeaders });
	}
	duyetNhapKho(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<PhieuKiemKe>(API_ROOT_URL + '/KhoKiemkekho_Update_StateConfirm', item, { headers: httpHeaders });
	}
	uploadFileImport(data): Observable<any> {
		const url = API_ROOT_URL + '/KhoKiemkekho_UploadFile';
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(url, data, { headers: httpHeaders });
	}
	downloadTemplate(): string  {
		
		return API_ROOT_URL + `/KhoKiemkeKho_DownLoadFileImportMau`;
	}

	  downloadTemplate_2(dataList:any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<Blob>(API_ROOT_URL + '/KhoKiemkeKho_DownLoadFileImportMau', dataList,{
		  headers: httpHeaders,
		  responseType: 'blob' as 'json'
		});
	  }
	listHangHoa(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = environment.ApiRoot + '/danhmuc' + '/Hang_Hoa_List';
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	listTonKho(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = environment.ApiRoot + '/dungchung/List_HangHoa_CoTon?more=true';
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	listLo(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = environment.ApiRoot + '/danhmuc/LotHH_List';
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	listListNCC(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = environment.ApiRoot + '/danhmuc' + '/DM_NCC_List';
		return this.http.post<any>(url, null, { headers: httpHeaders });
	}
	listKho(filterQuyen: boolean = false): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = environment.ApiRoot + '/danhmuc' + `/Kho_List?filterQuyen=${filterQuyen}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	listDVT(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = environment.ApiRoot + '/dvt/DM_DVT_Lite';
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	listState(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = environment.ApiRoot + '/dungchung' + `/TrangThaiPhieu_List?category=KK`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	listNV(IdPB: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = environment.ApiRoot + '/dungchung' + `/NhanVienPB_List?id=${IdPB}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	getDSVTK(IdKho: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = environment.ApiRoot + '/dungchung' + `/ViTriKho_List?IdKho=${IdKho}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	setNhapXuatKho(IdKK: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = environment.ApiRoot + '/kho' + `/TaoPhieuXuatNhapKho_TypeAnother?IdKK=${IdKK}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	downloadExcel(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<Blob>(API_ROOT_URL + '/KK_ExportExcel', {
		  headers: httpHeaders,
		  responseType: 'blob' as 'json'
		});
	  }
}
